<template>
    <aside>
        <div class="titulo margem efeito">
            <div class="m-icone">
                <a
                    href="#"
                    class="icone-menu"
                    title="Menu"
                    onclick="document.getElementById('main').classList.toggle('esconde');return false"
                ></a>
            </div>
        </div>
        <div class="separador margem linha">
            <div class="m-icone">
                <router-link to="/" class="icone-smartphone" active-class="ativo" title="Monitoramento"></router-link>
            </div>
        </div>

        <nav class="nav-maior separador">
            <div class="separador">
                <router-link to="/" active-class="ativo">Monitoramento</router-link>
            </div>
        </nav>
    </aside>
</template>

<script>
export default {};
</script>
